<template>
  <a-select
    v-bind="attrs"
    ref="selectRef"
    :max-tag-count="getMaxTagCount"
    :max-tag-text-length="getMaxTagTextLength"
    :class="[bem.b(), bem.is(isGray ? 'gray-select' : '')]"
  >
    <template v-for="item in Object.keys($slots)" :key="item" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-select>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
// import { Select } from 'ant-design-vue'
import { computed, ref, useAttrs } from 'vue'
import { selectProps } from './select'

defineOptions({ name: 'LlSelect' })

const bem = createNamespace('select')
const props = defineProps(selectProps)

const attrs = useAttrs()

const selectRef = ref()

const getMaxTagCount = computed(() => {
  return typeof props.maxTagCount === 'number'
    ? props.maxTagCount <= 0
      ? null
      : props.maxTagCount
    : null
})

const getMaxTagTextLength = computed(() => {
  return typeof props.maxTagTextLength === 'number'
    ? props.maxTagTextLength <= 0
      ? null
      : props.maxTagTextLength
    : null
})

const focus = () => {
  selectRef.value.focus()
}

const blur = () => {
  selectRef.value.blur()
}
defineExpose({
  focus,
  blur,
})
</script>
